import { render } from "./CompanyProfileSection.vue?vue&type=template&id=51822d34"
import script from "./CompanyProfileSection.vue?vue&type=script&lang=js"
export * from "./CompanyProfileSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__